module.exports = __webpack_public_path__ + "static/media/wizualizacja-56.8574aac5.png";